import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { pluck } from 'rxjs/operators';
const getSupportRequestReasonsQuery = gql`query get_support_request_reasons{
  support_request_reasons{
    id
    created_at
    updated_at
    name
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupportRequestReasonsService {

  constructor(private apollo: Apollo) { }

  getSupportRequestReasons(){
    return this.apollo.use('external').query({
      query: getSupportRequestReasonsQuery
    }).pipe(pluck('data','support_request_reasons'));
  }

}
